import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { closeFormLayoutModal } from './closeModal';
import * as persistentState from '../../utils/persistentState';
import { selectSendFeedbackSucceed } from '../../selectors/sendFeedback';
export function saveAndCloseFormLayoutModal(values) {
  var _ref;
  return function (_x, _x2, _x3) {
    return (_ref = _ref || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var state, isSendFeedbackSucceed;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            isSendFeedbackSucceed = selectSendFeedbackSucceed(state);
            if (!isSendFeedbackSucceed) {
              persistentState.save(values);
            }
            _context.next = 5;
            return dispatch(closeFormLayoutModal(values));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))).apply(this, arguments);
  };
}